export enum ConfidentialityRating {
    Tier1 = 'Tier 1',
    Tier2 = 'Tier 2',
    Tier3 = 'Tier 3',
}